import React, { useState, useContext, useEffect } from 'react';
import { ethers } from 'ethers';
import { ThemeContext } from '../context/ThemeContext';
import { Dropdown, Tab, Nav, Modal, Button } from 'react-bootstrap';
import swal from 'sweetalert';
import './CreateToken.css'
import contractABI from './ABI/contractABI.json'
import sourceCode0 from './SourceCode/ZeroTax.txt'
import sourceCode1 from './SourceCode/ZeroTax.txt'
import sourceCode2 from './SourceCode/ZeroTax.txt'

// const contractAddress = '0xD93A2C9E251ceeFbF56BFF007f39B7ecdD7b86CC';

const CreateToken = () => {

    //  傳入語言 地址
    const {
        language,
        defaultAccount,
    } = useContext(ThemeContext);


    //  設定複製內容
    const copyToClipboard = (value) => {
        try {
            navigator.clipboard.writeText(value);
        } catch (err) {
            console.log(err)
        }
    };

    //  抓取合約代碼
    const fetchFileContents = async (value) => {
        try {
            let fetchingCode;
            switch (value) {
                case 0:
                    fetchingCode = sourceCode0;
                    break;
                case 1:
                    fetchingCode = sourceCode1;
                    break;
                case 2:
                    fetchingCode = sourceCode2;
                    break;
                // add more cases for each option
                default:
                    fetchingCode = null;
            }
            const response = await fetch(fetchingCode);
            const text = await response.text();
            // setFileContent(text);

            copyToClipboard(text);

            swal('Success', 'Copy Success', 'success')
        } catch (err) {
            console.log(err)
        }
    };

    /* 
    不同鍊 這邊要改
    Different Chain
*/
    //一鍵發幣Proxy地址
    const contractAddress = '0x7Ba3467722F95a8eB487ECC7055905e9C8F9BCFC';

    const DexOptions = [
        {
            contract: '0xD99D1c33F9fC3444f8101754aBC46c52416550D1',
            texts: 'PancakeSwap'
        },
        {
            contract: '',
            texts: 'Other'
        }
    ]

    const CurrencyOptions = [
        {
            contract: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',   //WBNB  - TESTNET
            texts: 'BNB'
        },
        {
            contract: '0x7ef95a0FEE0Dd31b22626fA2e10Ee6A223F8a684',   //USDT  - TESTNET
            texts: 'USDT'
        },
        {
            contract: '0xaB1a4d4f1D656d2450692D237fdD6C7f9146e814',   //BUSD  - TESTNET
            texts: 'BUSD'
        },
        {
            contract: '',
            texts: 'Other'
        },
    ]

    const RewardTokenOptions = [
        {
            contract: '0x7ef95a0FEE0Dd31b22626fA2e10Ee6A223F8a684',   //WBNB  - TESTNET
            texts: 'USDT'
        },
        {
            contract: '0xaB1a4d4f1D656d2450692D237fdD6C7f9146e814',   //USDT  - TESTNET
            texts: 'DOGE'
        },
        {
            contract: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',   //BUSD  - TESTNET
            texts: 'SHIB'
        },
        {
            contract: '',
            texts: 'Other'
        },
    ]


    //下拉式選單
    const [selectedModuleValue, setSelectedModuleValue] = useState(0)
    const [selectedSwapValue, setSelectedSwapValue] = useState(0)
    const [selectedBaseValue, setSelectedBaseValue] = useState(0)
    const [selectedRewardValue, setSelectedRewardValue] = useState(0)

    //選擇分紅幣時 顯示分紅選項
    const [showRewardContent, setShowRewardContent] = useState(true)

    //各區域是否展開
    const [isOpen, setIsOpen] = useState([true, true, true, true, true])

    //開關選擇是否選擇
    const [isBoxChecked, setIsBoxChecked] = useState([false, false, false, false, false, false, false])
    //開關的值
    const [killBlock, setKillBlock] = useState(0);

    //基本資訊
    const [name, setName] = useState(null);
    const [symbol, setSymbol] = useState(null);
    const [supply, setSupply] = useState(0);
    const [decimal, setDecimal] = useState(0);

    //進階資訊
    const [showWallet2, setShowWallet2] = useState(false);

    const [marketingWallet, setMarketingWallet] = useState(null)
    const [marketingWallet2, setMarketingWallet2] = useState(null)
    const [fundRatio, setFundRatio] = useState(100);
    const [dex, setDex] = useState(DexOptions[0].contract)
    const [currency, setCurrency] = useState(CurrencyOptions[0].contract)
    const [rewardToken, setRewardToken] = useState(RewardTokenOptions[0].contract)

    //買稅
    const [buyMarketing, setBuyMarketing] = useState(0)
    const [buyLiquidity, setBuyLiquidity] = useState(0)
    const [buyBurn, setBuyBurn] = useState(0)
    const [buyReward, setBuyReward] = useState(0)
    const [isBuyInvalid, setIsBuyInvalid] = useState(false)

    //賣稅
    const [sellMarketing, setSellMarketing] = useState(0)
    const [sellLiquidity, setSellLiquidity] = useState(0)
    const [sellBurn, setSellBurn] = useState(0)
    const [sellReward, setSellReward] = useState(0)
    const [isSellInvalid, setIsSellInvalid] = useState(false)

    //連接錢包
    const [provider, setProvider] = useState(null)
    const [signer, setSigner] = useState(null)
    //模板中心合約
    const [contract, setContract] = useState(null)
    const [templateFee, setTemplateFee] = useState(0.05);
    //部署資訊
    const [params, setParams] = useState([]);
    const [encodedABI, setEncodedABI] = useState(null);
    const [modalWithTooltip, setModalWithTooltip] = useState(false);
    const [salt, setSalt] = useState(0);
    const [deployedCA, setDeployedCA] = useState(null);

    const updateEthers = async () => {
        let tempProvider = new ethers.providers.Web3Provider(window.ethereum);
        setProvider(tempProvider);

        let tempSigner = tempProvider.getSigner();
        setSigner(tempSigner);

        let tempContract = new ethers.Contract(contractAddress, contractABI, tempSigner)
        setContract(tempContract);

        let tempFee = await tempContract.moduleNumToRequiredEther(0);
        let FeeInEther = ethers.utils.formatEther(tempFee);
        setTemplateFee(FeeInEther);
    }

    useEffect(() => {
        updateEthers();
    }, [defaultAccount])

    const titletexts = [
        language.value === 'english'        //0
            ? 'Token Creator'
            : language.value === 'chinese'
                ? '创建代币'
                : '創建代幣',
        language.value === 'english'        //1
            ? 'Token Type'
            : language.value === 'chinese'
                ? '代币类型'
                : '代幣類型',
        language.value === 'english'        //2
            ? 'Basic Info'
            : language.value === 'chinese'
                ? '基本参数'
                : '基本參數',
        language.value === 'english'        //3
            ? 'Advanced Info'
            : language.value === 'chinese'
                ? '进阶参数'
                : '進階參數',
        language.value === 'english'        //4
            ? 'Contract address'
            : language.value === 'chinese'
                ? '合约地址'
                : '合約地址',
        language.value === 'english'        //5
            ? 'Buy Taxes'
            : language.value === 'chinese'
                ? '买入税率'
                : '買入稅率',
        language.value === 'english'        //6
            ? 'Sell Taxes'
            : language.value === 'chinese'
                ? '卖出税率'
                : '賣出稅率',
        language.value === 'english'        //7
            ? 'Function Switches'
            : language.value === 'chinese'
                ? '功能开关'
                : '功能開關',
        language.value === 'english'        //8
            ? 'Total Fees'
            : language.value === 'chinese'
                ? '买入税总和'
                : '買入稅總和',
        language.value === 'english'        //9
            ? 'Total Fees'
            : language.value === 'chinese'
                ? '卖出税总和'
                : '賣出稅總和',
        language.value === 'english'        //10
            ? 'Deploy'
            : language.value === 'chinese'
                ? '部署'
                : '部署',
        language.value === 'english'              //11
            ? 'Wallet'
            : language.value === 'chinese'
                ? '钱包'
                : '錢包',
        language.value === 'english'              //12
            ? 'Contract Information'
            : language.value === 'chinese'
                ? '合约资讯'
                : '合約資訊',
        language.value === 'english'              //13
            ? 'Contract Address'
            : language.value === 'chinese'
                ? '合约地址'
                : '合約地址',
        language.value === 'english'              //13
            ? 'Open Source Configuration'
            : language.value === 'chinese'
                ? '开源设定'
                : '開源設定',
        language.value === 'english'              //14
            ? 'Add 2nd Marketing Wallet'
            : language.value === 'chinese'
                ? '新增第二营销钱包'
                : '新增第二營銷錢包',
        language.value === 'english'              //14
            ? 'Remove 2nd Marketing Wallet'
            : language.value === 'chinese'
                ? '移除第二营销钱包'
                : '移除第二營銷錢包',
    ]

    /*
        Parameters
    */
    const marketingWalletText = language.value === 'english' ? 'Marketing Wallet' : language.value === 'chinese' ? '营销钱包' : '營銷錢包';
    const marketingWalletText2 = language.value === 'english' ? 'Marketing Wallet 2' : language.value === 'chinese' ? '营销钱包2' : '營銷錢包2';
    const marketingWalletText3 = language.value === 'english' ? 'Marketing Ratio' : language.value === 'chinese' ? '营销比例' : '營銷比例';
    const marketingWalletPlaceholder = 'Ex: 0x000000000000000000000000000000000000dEaD';
    const marketingWalletMustFillContent = language.value === 'english' ? 'The wallet which receives the marketing tax and liquidity back when you have these two taxes. You can set the wallet linked to the webiste as the marketing wallet by clicking on the wallet button' : language.value === 'chinese' ? '收取营销税以及回流的钱包。点击钱包按钮，可直接使用连接中钱包设为营销钱包' : '收取營銷稅以及回流的錢包。點擊錢包按鈕，可直接使用連接中錢包設為營銷錢包';
    const marketingWalletMustFillContent2 = language.value === 'english' ? 'The wallet which receives the marketing tax. You can set the wallet linked to the webiste as the marketing wallet by clicking on the wallet button' : language.value === 'chinese' ? '收取营销税的钱包。点击钱包按钮，可直接使用连接中钱包设为营销钱包' : '收取營銷稅的錢包。點擊錢包按鈕，可直接使用連接中錢包設為營銷錢包';
    const marketingWalletMustFillContent3 = language.value === 'english' ? 'The marketing percentage that goes to the marketing wallet 1, the ratio should between 0 to 100.' : language.value === 'chinese' ? '营销资金送往营销钱包1的比例，该数字应在 0 到 100 之间' : '營銷資金送往營銷錢包1的比例，該數字應在 0 到 100 之間';

    const nameText = language.value === 'english' ? 'Name' : language.value === 'chinese' ? '代币全称' : '代幣全稱';
    const symbolText = language.value === 'english' ? 'Symbol' : language.value === 'chinese' ? '代币简称' : '代幣簡稱';
    const supplyText = language.value === 'english' ? 'Supply' : language.value === 'chinese' ? '代币总量' : '代幣總量';
    const decimalText = language.value === 'english' ? 'Decimal' : language.value === 'chinese' ? '代币精度' : '代幣精度';

    const namePlaceholder = 'Ex: Ethereum';
    const symbolPlaceholder = 'Ex: ETH';
    const supplyPlaceholder = language.value === 'english' ? 'Ex: 1000000' : language.value === 'chinese' ? '例如：1000000' : '例如：1000000';
    const decimalPlaceholder = language.value === 'english' ? 'Number between 0 to 18' : language.value === 'chinese' ? '0 到 18 的数字' : '0 到 18 的數字';

    const nameMustFillContent = language.value === 'english' ? 'The whole name of the token. Ex : Ethereum' : language.value === 'chinese' ? '代币的全部名称，布署后名称无法再更改，请谨慎考虑' : '代幣的全部名稱，布署後名稱無法再更改，請謹慎考慮';
    const symbolMustFillContent = language.value === 'english' ? 'The abbreviation of the token. Ex : ETH' : language.value === 'chinese' ? '代币的缩写，布署后名称无法再更改，请谨慎考虑' : '代幣的縮寫，布署後名稱無法再更改，請謹慎考慮';
    const supplyMustFillContent = language.value === 'english' ? 'The total supply of your token, this amount cannot be increased after you deploy' : language.value === 'chinese' ? '代币的总数量，该数量在布署后无法再增加' : '代幣的總數量，該數量在布署後無法再增加';
    const decimalMustFillContent = language.value === 'english' ? 'The number of digits you have after the decimal point, please input number between 0 and 18' : language.value === 'chinese' ? '代币在小数点后有多少位数， 请输入0 到 18的数字' : '代幣在小數點後有多少位數， 請輸入0 到 18的數字';


    const basicDatas = [
        {
            text: nameText,
            placeholder: namePlaceholder,
            mustFill: true,
            mustFillContent: nameMustFillContent,
            function: (e) => setName(e.target.value),
            type: "text",
            defaultValue: name,
        },
        {
            text: symbolText,
            placeholder: symbolPlaceholder,
            mustFill: true,
            mustFillContent: symbolMustFillContent,
            function: (e) => setSymbol(e.target.value),
            type: "text",
            defaultValue: symbol,
        },
        {
            text: supplyText,
            placeholder: supplyPlaceholder,
            mustFill: true,
            mustFillContent: supplyMustFillContent,
            function: (e) => setSupply(e.target.value),
            type: "number",
            defaultValue: supply,
        },
        {
            text: decimalText,
            placeholder: decimalPlaceholder,
            mustFill: true,
            mustFillContent: decimalMustFillContent,
            function: (e) => {
                if (e.target.value > 18) {
                    swal("Wrong", "You can not set decimal higher than 18", "error");
                    // setDecimal(18);
                    // return;
                }
                if (e.target.value < 0) {
                    swal("Wrong", "You can not set decimal lower than 0", "error");
                    // setDecimal(0);
                    // return;
                }
                setDecimal(e.target.value);
            },
            type: "number",
            defaultValue: decimal,
        },
    ];
    const advancedDatas = [
        {
            text: marketingWalletText,
            id: "marketingWallet1",
            placeholder: marketingWalletPlaceholder,
            mustFill: true,
            mustFillContent: marketingWalletMustFillContent,
            function: (e) => setMarketingWallet(e.target.value),
            defaultValue: marketingWallet,
        },
        {
            text: marketingWalletText2,
            id: "marketingWallet2",
            placeholder: marketingWalletPlaceholder,
            mustFill: true,
            mustFillContent: marketingWalletMustFillContent2,
            function: (e) => setMarketingWallet2(e.target.value),
            defaultValue: marketingWallet2,
            show: showWallet2,
        },
        {
            text: marketingWalletText3,
            id: "marketingWallet2",
            placeholder: marketingWalletPlaceholder,
            mustFill: true,
            mustFillContent: marketingWalletMustFillContent3,
            function: (e) => setFundRatio(e.target.value),
            defaultValue: fundRatio,
            show: showWallet2,
        },
    ];


    const advancedDropdowns = [
        {
            text:
                language.value === 'english'
                    ? 'DEX'
                    : language.value === 'chinese'
                        ? '交易所'
                        : '交易所',
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? 'The decentralized exchange you want to trade on, please provide your initial liquidity pool in the dex you choose.'
                    : language.value === 'chinese'
                        ? '设置想要在哪个去中心化交易所进行交易，在提供初始流动性时，请提供在选定的交易所上'
                        : '設置想要在哪個去中心化交易所進行交易，在提供初始流動性時，請提供在選定的交易所上',
            content: DexOptions,
            selected: selectedSwapValue,
            defaultValue: dex,
        },
        {
            text:
                language.value === 'english'
                    ? 'Currency'
                    : language.value === 'chinese'
                        ? '底池'
                        : '底池',
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? 'The currency you want to provide in the initial liquidity pool'
                    : language.value === 'chinese'
                        ? '设置想要以哪个币种作为底池进行交易，在提供初始流动性时，请提供所选定的底池币种'
                        : '設置想要以哪個幣種作為底池進行交易，在提供初始流動性時，請提供所選定的底池幣種',
            content: CurrencyOptions,
            selected: selectedBaseValue,
            defaultValue: currency,
        },
        {
            text:
                language.value === 'english'
                    ? 'Reward Token'
                    : language.value === 'chinese'
                        ? '分红代币'
                        : '分紅代幣',
            mustFill: true,
            content: RewardTokenOptions,
            selected: selectedRewardValue,
            defaultValue: rewardToken,
        },
    ]

    const buyTaxes = [
        {
            text:
                language.value === 'english'
                    ? 'Buy Marketing Fee'
                    : language.value === 'chinese'
                        ? '买入营销税'
                        : '買入營銷稅',
            placeholder: 'Ex: 0',
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? 'The marketing tax when buying, which provides funds to marketing wallet'
                    : language.value === 'chinese'
                        ? '在买入时收取营销税率，为营销钱包提供资金'
                        : '在買入時收取營銷稅率，為營銷錢包提供資金',
            function: (e) => setBuyMarketing(e.target.value),
            defaultValue: buyMarketing,
        },
        {
            text:
                language.value === 'english'
                    ? 'Buy Liquidity Fee'
                    : language.value === 'chinese'
                        ? '买入回流税'
                        : '買入回流稅',
            placeholder: 'Ex: 0',
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? 'The liquidity tax when buying, which generates liquidity pool and send to marketing wallet'
                    : language.value === 'chinese'
                        ? '在买入时收取回流税率，为营销钱包提供回流的流动池'
                        : '在買入時收取回流稅率，為營銷錢包提供回流的流動池',
            function: (e) => setBuyLiquidity(e.target.value),
            defaultValue: buyLiquidity,
        },
        {
            text:
                language.value === 'english'
                    ? 'Buy Burn Fee'
                    : language.value === 'chinese'
                        ? '买入燃烧税'
                        : '買入燃燒稅',
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? 'The burn tax when buying, which transfer tokens to the dead address'
                    : language.value === 'chinese'
                        ? '在买入时收取燃烧税率，向黑洞地址转移代币，进行永久销毁'
                        : '在買入時收取燃燒稅率，向黑洞地址轉移代幣，進行永久銷毀',
            function: (e) => setBuyBurn(e.target.value),
            defaultValue: buyBurn,
        },
        {
            text:
                language.value === 'english'
                    ? 'Buy Reward Fee'
                    : language.value === 'chinese'
                        ? '买入分红税'
                        : '買入分紅稅',
            placeholder: 'Ex: 0',
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? 'The reward tax when buying, which rewards the token holders'
                    : language.value === 'chinese'
                        ? '在买入时收取分红税率，对代币的持有者进行分红'
                        : '在買入時收取分紅稅率，對代幣的持有者進行分紅',
            function: (e) => setBuyReward(e.target.value),
            defaultValue: buyReward,
        },
    ]
    const SellTaxes = [
        {
            text:
                language.value === 'english'
                    ? 'Sell Marketing Fee'
                    : language.value === 'chinese'
                        ? '卖出营销税'
                        : '賣出營銷稅',
            placeholder: 'Ex: 0',
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? 'The marketing tax when selling, which provides funds to marketing wallet'
                    : language.value === 'chinese'
                        ? '在卖出时收取营销税率，为营销钱包提供资金'
                        : '在賣出時收取營銷稅率，為營銷錢包提供資金',
            function: (e) => setSellMarketing(e.target.value),
            defaultValue: sellMarketing,
        },
        {
            text:
                language.value === 'english'
                    ? 'Sell Liquidity Fee'
                    : language.value === 'chinese'
                        ? '卖出回流税'
                        : '賣出回流稅',
            placeholder: 'Ex: 0',
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? 'The liquidity tax when selling, which generates liquidity pool and send to marketing wallet'
                    : language.value === 'chinese'
                        ? '在卖出时收取回流税率，为营销钱包提供回流的流动池'
                        : '在賣出時收取回流稅率，為營銷錢包提供回流的流動池',
            function: (e) => setSellLiquidity(e.target.value),
            defaultValue: sellLiquidity,
        },
        {
            text:
                language.value === 'english'
                    ? 'Sell Burn Fee'
                    : language.value === 'chinese'
                        ? '卖出燃烧税'
                        : '賣出燃燒稅',
            placeholder: 'Ex: 0',
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? 'The burn tax when selling, which transfer tokens to the dead address'
                    : language.value === 'chinese'
                        ? '在卖出时收取燃烧税率，向黑洞地址转移代币，进行永久销毁'
                        : '在賣出時收取燃燒稅率，向黑洞地址轉移代幣，進行永久銷毀',
            function: (e) => setSellBurn(e.target.value),
            defaultValue: sellBurn,
        },
        {
            text:
                language.value === 'english'
                    ? 'Sell Reward Fee'
                    : language.value === 'chinese'
                        ? '卖出分红税'
                        : '賣出分紅稅',
            placeholder: 'Ex: 0',
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? 'The reward tax when selling, which rewards the token holders'
                    : language.value === 'chinese'
                        ? '在卖出时收取分红税率，对代币的持有者进行分红'
                        : '在賣出時收取分紅稅率，對代幣的持有者進行分紅',
            function: (e) => setSellReward(e.target.value),
            defaultValue: sellReward,
        },
    ]

    const functionControls = [
        {
            text:
                language.value === 'english'
                    ? 'Open Trade'
                    : language.value === 'chinese'
                        ? '交易开关'
                        : '交易開關',
            selected: false,
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? `With this function, you can manually open the trade in the console.
                    The transaction cannot be stopped once trading started`
                    : language.value === 'chinese'
                        ? '当开启此开关，你可以透过开盘按钮来手动开启交易，当开启交易后，交易不能被停止'
                        : '當開啟此開關，你可以透過開盤按鈕來手動開啟交易，當開啟交易後，交易不能被停止',
        },
        {
            text:
                language.value === 'english'
                    ? 'Anti Bot'
                    : language.value === 'chinese'
                        ? '杀机器人'
                        : '殺機器人',
            selected: false,
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? `With this function, buyers buy within the blocks you set since the open trading block would be automatically blacklisted.`
                    : language.value === 'chinese'
                        ? '当开启此开关，你可以设定自动拉黑开盘10区块以内的购买者，用以防止机器人购买'
                        : '當開啟此開關，你可以設定自動拉黑開盤10區塊以內的購買者，用以防止機器人購買',
            placeholder: 'blocks',
            defaultValue: killBlock,
            function: (e) => {
                if (e.target.value > 10) setKillBlock(10)
                else if (e.target.value < 0) setKillBlock(0)
                else setKillBlock(e.target.value)
            }
        },
        {
            text:
                language.value === 'english'
                    ? 'Blacklist'
                    : language.value === 'chinese'
                        ? '拉黑功能'
                        : '拉黑功能',
            selected: false,
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? `With this function, the addresses that are blacklisted cannot trade anymore.`
                    : language.value === 'chinese'
                        ? '当开启此开关，你可以透过手动拉黑来进行地址的拉黑操作，使其无法交易'
                        : '當開啟此開關，你可以透過手動拉黑來進行地址的拉黑操作，使其無法交易',
        },
        {
            text:
                language.value === 'english'
                    ? 'Tax Adjustment'
                    : language.value === 'chinese'
                        ? '调税功能'
                        : '調稅功能',
            selected: false,
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? `With this function, you can adjust the tax after the token created.
                    The tax cannot be set higher than 25%`
                    : language.value === 'chinese'
                        ? '当开启此开关，开盘后可进行税率的更改，总买入税 与 总卖出税 皆无法超过25%'
                        : '當開啟此開關，開盤後可進行稅率的更改，總買入稅 與 總賣出稅 皆無法超過25%',
        },
        {
            text:
                language.value === 'english'
                    ? 'Transfer Tax'
                    : language.value === 'chinese'
                        ? '转帐税率'
                        : '轉帳稅率',
            selected: false,
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? `With this function, you can decide whether to take tax during transfer or not`
                    : language.value === 'chinese'
                        ? '当开启此开关，你可以对转帐时收取与卖出税率相同的税率'
                        : '當開啟此開關，你可以對轉帳時收取與賣出稅率相同的稅率',
        },
        {
            text:
                language.value === 'english'
                    ? 'Wallet Limitation'
                    : language.value === 'chinese'
                        ? '钱包限制'
                        : '錢包限制',
            selected: false,
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? `With this function, you can setup the maximum amount of token that a address can hold`
                    : language.value === 'chinese'
                        ? '当开启此开关，你可以设定单一钱包的最大持仓，用户无法持有超过该设定的代币总量'
                        : '當開啟此開關，你可以設定單一錢包的最大持倉，用戶無法持有超過該設定的代幣總量',
        },
        {
            text:
                language.value === 'english'
                    ? 'Transaction Limit'
                    : language.value === 'chinese'
                        ? '交易限制'
                        : '交易限制',
            selected: false,
            mustFill: true,
            mustFillContent:
                language.value === 'english'
                    ? `With this function, you can setup the maximum amount of token that a address can buy or sell in one transaction`
                    : language.value === 'chinese'
                        ? '当开启此开关，你可以设定一笔交易的买入数量限制与卖出数量限制，用户在一笔交易中，无法交易超过你设定的数量'
                        : '當開啟此開關，你可以設定一筆交易的買入數量限制與賣出數量限制，用戶在一筆交易中，無法交易超過你設定的數量',
        },

    ]

    const selectModuleValue = async (value) => {
        //  在選定模板的時候 獲取模板價格
        let tempFee = await contract.moduleNumToRequiredEther(value);
        let FeeInEther = ethers.utils.formatEther(tempFee);
        console.log(tempFee)
        console.log(FeeInEther);
        setTemplateFee(FeeInEther);

        console.log(value)
        setSelectedModuleValue(value)

        if (value === 2)
            setShowRewardContent(true)
        else
            setShowRewardContent(false)
    }

    const handleOtherSituationInDropdown = (index, value) => {
        if (index === 0) {
            setDex(value)
            console.log("Setting Dex :" + value)
        }
        if (index === 1) {
            setCurrency(value)
            console.log("Setting Currency :" + value)
        }
        if (index === 2) {
            setRewardToken(value)
            console.log("Setting Token :" + value)
        }
    }

    const handleDropdownSelection = (index, indexed) => {
        if (index === 0) {
            console.log("Choosing Swap")
            setSelectedSwapValue(indexed);
            if (DexOptions[indexed].contract !== '')
                setDex(DexOptions[indexed].contract)
        }
        if (index === 1) {
            setSelectedBaseValue(indexed);
            if (indexed !== 3)
                setCurrency(CurrencyOptions[indexed].contract)
        }
        if (index === 2) {
            setSelectedRewardValue(indexed);
            if (indexed !== 3)
                setRewardToken(RewardTokenOptions[indexed].contract)
        }
    }

    const handleCheckBox = (index) => {
        console.log(index)
        setIsBoxChecked(prevState => {
            const newState = [...prevState];
            newState[index] = !prevState[index];
            return newState;
        })
    }

    const TaxSum = (market, lp, burn, reward, isBuy) => {
        let sum = market + lp + burn + reward;
        if (sum > 25 || sum < 0) {
            if (isBuy && !isBuyInvalid) setIsBuyInvalid(true)
            if (!isBuy && !isSellInvalid) setIsSellInvalid(true)
        } else {
            if (isBuy && isBuyInvalid) setIsBuyInvalid(false)
            if (!isBuy && isSellInvalid) setIsSellInvalid(false)
        }

        return market + lp + burn + reward;
    }

    const beforedeploy = () => {
        const errors = [];


        //  檢查 基礎訊息
        if (!name) {
            errors.push(language.value === 'english' ? 'Name' : language.value === 'chinese' ? '代币全称' : '代幣全稱');
        }
        if (!symbol) {
            errors.push(language.value === 'english' ? 'Symbol' : language.value === 'chinese' ? '代币简称' : '代幣簡稱');
        }
        if (decimal < 0 || decimal > 18 || !decimal) {
            errors.push(language.value === 'english' ? 'Decimal' : language.value === 'chinese' ? '代币精度' : '代幣精度');
        }
        if (supply <= 0 || !supply || Number(supply.length) + Number(decimal) > 38) {
            errors.push(language.value === 'english' ? 'Supply' : language.value === 'chinese' ? '代币总量' : '代幣總量');
        }

        if (errors.length) {
            const ErrorString = language.value === 'english' ? 'Error' : language.value === 'chinese' ? '错误' : '錯誤';
            const errorString = errors.map((error) => `${error} ${ErrorString}`).join('\n');
            swal(ErrorString, errorString, 'error');
            return false;
        }

        return true;
    };


    const generateSalt = () => {
        let randomNumber = Math.floor(Math.random() * Math.pow(10, 15)) + 1;
        setSalt(randomNumber);
        return randomNumber;
    }

    const generateContractAddressBeforeDeploy = async (saltNum, params) => {
        try {
            let generatedAddress = await contract.getAddressBeforeDeploy(
                selectedModuleValue, saltNum,
                params[0],
                params[1],
                params[2],
                params[3]
            )
            console.log(generatedAddress);
            setDeployedCA(generatedAddress);
        } catch (error) {
            console.log(error)
        }
    }

    const generateEncodedABI = (params) => {
        const encodedConstructorArgs = ethers.utils.defaultAbiCoder.encode(
            ["uint256[]", "string[]", "address[]", "bool[]"],
            [params[0], params[1], params[2], params[3]]
        );
        setEncodedABI(encodedConstructorArgs.slice(2));
    }

    const gettingParams = () => {
        // String Params don't change
        let stringParams = [name, symbol];

        // Changeable Settings
        let numParams;
        let addressParams;
        let boolParams;

        let isCurrencyETH = false;
        if (currency == CurrencyOptions[0].contract) {
            isCurrencyETH = true
        }

        switch (selectedModuleValue) {
            case 2: {
                numParams =
                    [
                        supply, decimal,
                        buyMarketing, buyBurn, buyLiquidity,
                        sellMarketing, sellBurn, sellLiquidity,
                        0,
                        supply / 100, supply / 100, supply / 100,
                        3
                    ]
                addressParams = [currency, dex, defaultAccount, marketingWallet]
                boolParams =
                    [
                        isCurrencyETH, isBoxChecked[0], isBoxChecked[1], isBoxChecked[2],
                        isBoxChecked[3], isBoxChecked[4], isBoxChecked[5], isBoxChecked[6]
                    ]
                break;

            }
            case 1: {
                numParams =
                    [
                        supply, decimal,
                        buyMarketing * 100, buyBurn * 100, buyLiquidity * 100,
                        sellMarketing * 100, sellBurn * 100, sellLiquidity * 100,
                        killBlock,
                        supply / 100, supply / 100, supply / 100,
                        3,
                        fundRatio
                    ]
                addressParams = [currency, dex, defaultAccount, marketingWallet, marketingWallet2]
                boolParams =
                    [
                        isCurrencyETH, isBoxChecked[0], isBoxChecked[1], isBoxChecked[2],
                        isBoxChecked[3], isBoxChecked[4], isBoxChecked[5], isBoxChecked[6]
                    ]
                break;
            }
            default: {
                numParams = [supply, decimal]
                addressParams = []
                boolParams = []
            }
        }

        let parameters = [numParams, stringParams, addressParams, boolParams]
        setParams(parameters);
        return parameters;
    }

    const handleDeploy = async () => {
        console.log(
            `
            Marketing Wallet : ${marketingWallet}
            DEX : ${dex}
            Currency : ${currency}
            `
        )

        //  檢查基本資訊是否完善 => 否 則返回
        let basicInformationCheck = beforedeploy()
        if (!basicInformationCheck) return;
        let salt = generateSalt()
        let params = gettingParams();
        generateContractAddressBeforeDeploy(salt, params)
        generateEncodedABI(params)
        setModalWithTooltip(true)
    }

    const deployContract = async () => {


        try {
            let result = await contract.deploy(
                selectedModuleValue,
                salt,
                params[0],
                params[1],
                params[2],
                params[3]
            )
            console.log(result);
        } catch (error) {
            console.log(error);
            console.log(error.data.message)
        }


        console.log(isBoxChecked);
        console.log(`

        Addresses: ${dex}, ${marketingWallet}
        Strings: ${name},${symbol}
        uintsBuy: ${buyMarketing},${buyLiquidity},${buyBurn},${buyReward},
        uintsSell: ${sellMarketing},${sellLiquidity},${sellBurn},${sellReward},
        Supply : ${supply}
        Decimal: ${decimal}
        
        Buy Tax :${isBuyInvalid ? "Invalid" : "Normal"}
        Sell Tax:${isSellInvalid ? "Invalid" : "Normal"}
        `)
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h1> {titletexts[0]} </h1>
                    <div className="card d-flex flex-wrap">
                        <div className="card-header border-0 pb-0">
                            <h4 className="heading mb-0">{titletexts[1]} </h4>
                        </div>
                        <div className="card-body mb-12">
                            {/* <div className="d-flex align-items-center justify-content-between my-3">
                                <span className="small text-muted">Avbl Balance</span>
                                <span className="">210.800 USDT</span>
                            </div> */}
                            <form>
                                {/* <div className="input-group mb-3">
                                    <span className="input-group-text">Token Type</span>
                                    <input type="text" className="form-control" />
                                    <span className="input-group-text">USDT</span>
                                </div> */}


                                {/* 選擇合約模板 */}
                                <div className="input-group mb-3 d-flex flex-wrap align-items-center">
                                    <Dropdown>
                                        <Dropdown.Toggle
                                            className="form-control width-200 btn btn-primary btn-outline-primary right-radius"
                                            style={{ zIndex: 0, }}
                                        >{moduleDatas(language.value)[selectedModuleValue].text}</Dropdown.Toggle>
                                        <Dropdown.Menu align="end">
                                            {
                                                moduleDatas(language.value).map((moduleData, index) => {
                                                    return (
                                                        <div
                                                            key={index}
                                                            className='width-200 d-flex align-items-center'
                                                            style={{ padding: '5px' }}
                                                            onClick={() => selectModuleValue(index)}
                                                        >
                                                            <Dropdown.Item >
                                                                <div>{moduleData.text}</div>
                                                            </Dropdown.Item>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    <span className="form-control col-6" style={{ color: 'lightblue' }}>
                                        {templateFee} BNB
                                    </span>
                                </div>
                                <div style={{
                                    paddingLeft: '20px',
                                    paddingRight: '20px',
                                    fontSize: '16px',
                                    paddingTop: '20px'
                                }}>
                                    <span>{moduleDatas(language.value)[selectedModuleValue].description}</span>
                                </div>
                                {/* 選擇合約模板 */}

                                {/* 填寫合約模板內容 */}
                                {/* 基本內容 - Name, Symbol, Supply, Decimal */}
                                <div className="mb-3 mt-4">
                                    <h4 className="form-label">
                                        {titletexts[2]}
                                        <span
                                            style={{ paddingLeft: '20px', cursor: 'pointer', fontSize: '20px' }}
                                            onClick={() => setIsOpen(prevState => [!prevState[0], ...prevState.slice(1)])}
                                        >
                                            {
                                                isOpen[0] === true ? "▼" : "▶"
                                            }
                                        </span>
                                    </h4>
                                    {
                                        isOpen[0] === true &&
                                        basicDatas.map((data, index) => {
                                            return (
                                                <div key={index} className="input-group mb-3 align-items-center" style={{ paddingLeft: '20px' }}>
                                                    <span className="col-4">
                                                        {data.text}
                                                        {data.mustFill === true && mustFillDialog(data.mustFillContent)}
                                                    </span>

                                                    <div className='col-8'>
                                                        <input
                                                            type={data.type}
                                                            className="form-control"
                                                            placeholder={data.placeholder}
                                                            defaultValue={data.defaultValue}
                                                            onChange={data.function}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                {/* 基本內容 - Name, Symbol, Supply, Decimal */}


                                {/* 進階內容 - 營銷錢包 / 交易所 / 底池 / 分紅幣種 */}
                                {
                                    selectedModuleValue !== 0 &&
                                    <div className="mb-3 mt-4">
                                        <h4 className="form-label">
                                            {titletexts[3]}
                                            <span
                                                style={{ paddingLeft: '20px', cursor: 'pointer', fontSize: '20px' }}
                                                onClick={() =>
                                                    setIsOpen(prevState => {
                                                        const newState = [...prevState];
                                                        newState[1] = !prevState[1];
                                                        return newState;
                                                    })
                                                }
                                            >
                                                {
                                                    isOpen[1] === true ? "▼" : "▶"
                                                }
                                            </span>
                                        </h4>
                                        {
                                            isOpen[1] === true &&
                                            advancedDatas.map((data, index) => {
                                                if (data.show == false) return;
                                                return (
                                                    <div key={index} className="input-group mb-3 align-items-center" style={{ paddingLeft: '20px' }}>
                                                        <span className="col-4">
                                                            {data.text}
                                                            {data.mustFill === true && mustFillDialog(data.mustFillContent)}
                                                        </span>

                                                        <div className='col-5'>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id={data.id}
                                                                placeholder={data.placeholder}
                                                                defaultValue={data.defaultValue}
                                                                onChange={data.function} />
                                                        </div>

                                                        {
                                                            index !== 2 &&
                                                            <div className='col-3 form-control btn btn-primary btn-outline-primary d-flex align-items-center'
                                                                onClick={() => {
                                                                    if (index === 0) {
                                                                        setMarketingWallet(defaultAccount)
                                                                        let fundAddress = document.getElementById(data.id)
                                                                        fundAddress.value = defaultAccount;
                                                                    }
                                                                    if (index === 1) {
                                                                        setMarketingWallet2(defaultAccount)
                                                                        let fundAddress = document.getElementById(data.id)
                                                                        fundAddress.value = defaultAccount;
                                                                    }
                                                                }}
                                                                style={{ maxWidth: '100px' }}
                                                            >
                                                                <span>{titletexts[11]}</span>
                                                            </div>
                                                        }
                                                        {showWallet2 === false &&
                                                            <div className='row col-4'>
                                                                <span style={{ padding: '10px' }} onClick={() => setShowWallet2(true)}> + {titletexts[15]}</span>
                                                            </div>
                                                        }
                                                        {showWallet2 === true && index === 1 &&
                                                            <div className='row col-4'>
                                                                <span style={{ padding: '10px' }} onClick={() => setShowWallet2(false)}> - {titletexts[16]}</span>
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                        {
                                            isOpen[1] === true &&
                                            advancedDropdowns.map((data, index) => {
                                                if (index === 2 && showRewardContent === false) return;
                                                return (
                                                    <div key={index} className="input-group mb-3 align-items-center" style={{ paddingLeft: '20px' }}>
                                                        <span className="col-4">
                                                            {data.text}
                                                            {data.mustFill === true && mustFillDialog(data.mustFillContent)}
                                                        </span>

                                                        <div className='col-8'>
                                                            <Dropdown>
                                                                <Dropdown.Toggle
                                                                    className="width-200 btn btn-primary btn-outline-primary left-radius"
                                                                    style={{ maxWidth: '50vw' }}
                                                                >
                                                                    {
                                                                        data.content !== undefined &&
                                                                        data.content[data.selected].texts
                                                                    }
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu align="end">
                                                                    {
                                                                        data.content !== undefined &&
                                                                        data.content.map((moduleData, indexed) => {
                                                                            return (
                                                                                <div
                                                                                    key={indexed}
                                                                                    className='width-200 d-flex align-items-center'
                                                                                    style={{ padding: '5px' }}
                                                                                    onClick={() => {
                                                                                        handleDropdownSelection(index, indexed)
                                                                                    }}
                                                                                >
                                                                                    <Dropdown.Item >
                                                                                        <div>{moduleData.texts}</div>
                                                                                    </Dropdown.Item>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                        {
                                                            data.selected === (data.content.length - 1) &&
                                                            <div className='col-12 d-flex flex-direction-row align-items-center' >
                                                                <div className='col-4'>
                                                                </div>
                                                                <div className='col-8'>
                                                                    <input
                                                                        className='form-control'
                                                                        placeholder={titletexts[4]}
                                                                        onChange={(e) => handleOtherSituationInDropdown(index, e.target.value)}
                                                                        defaultValue={data.defaultValue} />
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                }

                                {/* 進階內容 - 買稅 */}
                                {
                                    selectedModuleValue !== 0 &&
                                    <div className="mb-3 mt-4">
                                        <h4 className="form-label">
                                            {titletexts[5]}
                                            <span
                                                style={{ paddingLeft: '20px', cursor: 'pointer', fontSize: '20px' }}
                                                onClick={() =>
                                                    setIsOpen(prevState => {
                                                        const newState = [...prevState];
                                                        newState[2] = !prevState[2];
                                                        return newState;
                                                    })
                                                }
                                            >
                                                {
                                                    isOpen[2] === true ? "▼" : "▶"
                                                }
                                            </span>
                                        </h4>
                                        {
                                            isOpen[2] === true &&
                                            <>
                                                {
                                                    buyTaxes.map((data, index) => {
                                                        if (index === 3 && showRewardContent === false) return;
                                                        return (
                                                            <div key={index} className="input-group mb-3 align-items-center" style={{ paddingLeft: '20px' }}>
                                                                <span className="col-4">
                                                                    {data.text}
                                                                    {data.mustFill === true && mustFillDialog(data.mustFillContent)}
                                                                </span>

                                                                <div className='col-8'>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder={data.placeholder}
                                                                        defaultValue={data.defaultValue}
                                                                        onChange={data.function} />
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                <div className='d-flex flex-direction-row'>
                                                    <div className='col-4'>
                                                        <span style={{ paddingLeft: '20px', }}>{titletexts[8]}</span>
                                                    </div>
                                                    <div className='col-8'>
                                                        <span style={{ paddingLeft: '20px', }}>
                                                            {
                                                                showRewardContent
                                                                    ?
                                                                    `${TaxSum(Number(buyLiquidity), Number(buyMarketing), Number(buyBurn), Number(buyReward), true) <= 30
                                                                        ? (TaxSum(Number(buyLiquidity), Number(buyMarketing), Number(buyBurn), Number(buyReward), true)).toFixed(2)
                                                                        : 'Invalid Tax. Tax should be less than or equal to 30'
                                                                    }`
                                                                    :
                                                                    `${TaxSum(Number(buyLiquidity), Number(buyMarketing), Number(buyBurn), Number(0), true) <= 30
                                                                        ? (TaxSum(Number(buyLiquidity), Number(buyMarketing), Number(buyBurn), Number(0), true)).toFixed(2)
                                                                        : 'Invalid Tax. Tax should be less than or equal to 30'
                                                                    }`
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                }
                                {/* 進階內容 - 買稅 */}

                                {/* 進階內容 - 賣稅 */}
                                {
                                    selectedModuleValue !== 0 &&
                                    <div className="mb-3 mt-4">
                                        <h4 className="form-label">
                                            {titletexts[6]}
                                            <span
                                                style={{ paddingLeft: '20px', cursor: 'pointer', fontSize: '20px' }}
                                                onClick={() =>
                                                    setIsOpen(prevState => {
                                                        const newState = [...prevState];
                                                        newState[3] = !prevState[3];
                                                        return newState;
                                                    })
                                                }
                                            >
                                                {
                                                    isOpen[3] === true ? "▼" : "▶"
                                                }
                                            </span>
                                        </h4>
                                        {
                                            isOpen[3] === true &&
                                            <>
                                                {
                                                    SellTaxes.map((data, index) => {
                                                        if (index === 3 && showRewardContent === false) return;
                                                        return (
                                                            <div key={index} className="input-group mb-3 align-items-center" style={{ paddingLeft: '20px' }}>
                                                                <span className="col-4">
                                                                    {data.text}
                                                                    {data.mustFill === true && mustFillDialog(data.mustFillContent)}
                                                                </span>

                                                                <div className='col-8'>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder={data.placeholder}
                                                                        defaultValue={data.defaultValue}
                                                                        onChange={data.function} />
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                <div className='d-flex flex-direction-row'>
                                                    <div className='col-4'>
                                                        <span style={{ paddingLeft: '20px', }}>{titletexts[9]}</span>
                                                    </div>
                                                    <div className='col-8'>
                                                        <span style={{ paddingLeft: '20px', }}>
                                                            {
                                                                showRewardContent
                                                                    ?
                                                                    `${TaxSum(Number(sellLiquidity), Number(sellMarketing), Number(sellBurn), Number(sellReward), false) <= 30
                                                                        ? (TaxSum(Number(sellLiquidity), Number(sellMarketing), Number(sellBurn), Number(sellReward), false)).toFixed(2)
                                                                        : 'Invalid Tax. Tax should be less than or equal to 30'
                                                                    }`
                                                                    :
                                                                    `${TaxSum(Number(sellLiquidity), Number(sellMarketing), Number(sellBurn), Number(0), false) <= 30
                                                                        ? (TaxSum(Number(sellLiquidity), Number(sellMarketing), Number(sellBurn), Number(0), false)).toFixed(2)
                                                                        : 'Invalid Tax. Tax should be less than or equal to 30'
                                                                    }`
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                }
                                {/* 進階內容 - 賣稅 */}
                                {/* 進階內容 - 功能開關 */}
                                {
                                    selectedModuleValue !== 0 &&
                                    <div className="mb-3 mt-4">
                                        <h4 className="form-label">
                                            {titletexts[7]}
                                            <span
                                                style={{ paddingLeft: '20px', cursor: 'pointer', fontSize: '20px' }}
                                                onClick={() =>
                                                    setIsOpen(prevState => {
                                                        const newState = [...prevState];
                                                        newState[4] = !prevState[4];
                                                        return newState;
                                                    })
                                                }
                                            >
                                                {
                                                    isOpen[4] === true ? "▼" : "▶"
                                                }
                                            </span>
                                        </h4>
                                        {
                                            isOpen[4] === true &&
                                            functionControls.map((functions, index) => {
                                                return (
                                                    <div key={index} style={{ paddingLeft: '20px', paddingTop: '10px' }}>
                                                        <div className='col-12 d-flex flex-direction-row'>
                                                            <div className='col-3 align-items-center'>
                                                                <p>
                                                                    {functions.text}

                                                                    {functions.mustFill === true && mustFillDialog(functions.mustFillContent)}
                                                                </p>
                                                            </div>

                                                            <div style={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                alignItems: 'center',
                                                                fontSize: '20px',
                                                                fontWeight: 'bold',
                                                                justifyContent: 'right',
                                                            }}>
                                                                <label
                                                                    className="switch">
                                                                    <input type="checkbox" onClick={() => handleCheckBox(index)} />
                                                                    <div className={`slider ${isBoxChecked[index] ? "on" : "off"}`}>
                                                                        <span className={`circle ${isBoxChecked[index] ? "right" : "left"}`}></span>
                                                                    </div>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        {
                                                            isBoxChecked[index] == true && functions.placeholder != undefined &&
                                                            <div className='col-12 d-flex flex-direction-row align-items-center'>
                                                                <div className='col-3'>
                                                                </div>
                                                                <div className='col-6'>
                                                                    <input className='form-control'
                                                                        placeholder={functions.placeholder}
                                                                        defaultValue={functions.defaultValue}
                                                                        onChange={functions.function}
                                                                    />
                                                                </div>
                                                            </div>}
                                                        {/* <div className='col-12 d-flex flex-direction-row align-items-center'>
                                                            <div className='col-3'>
                                                            </div>
                                                            <div className='col-6'>
                                                                <p>{functions.description}</p>
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                }
                                {/* 進階內容 - 功能開關 */}


                                {/* 部署合約 */}
                                <div className="mt-3 d-flex justify-content-center align-items-center" style={{ paddingTop: '20px' }}>
                                    <span className="btn btn-success py-2 text-uppercase"
                                        onClick={handleDeploy}
                                        style={{ cursor: 'pointer' }}>{titletexts[10]}</span>

                                    <span style={{ marginLeft: '20px' }}> {templateFee} BNB</span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {/* <WorkerExample /> */}

                <Modal className="fade" show={modalWithTooltip} style={{ marginTop: '15vh' }}>
                    <Modal.Header>
                        <Modal.Title>
                            {titletexts[12]}
                        </Modal.Title>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setModalWithTooltip(false)}
                        >

                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        <h5>{titletexts[13]}</h5>
                        <p>
                            {deployedCA}
                        </p>
                        <hr />

                        <h5>{titletexts[14]}</h5>
                        <p>
                            <span style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <span>Optimization: Yes</span>
                                <span>Runs: 200</span>
                            </span> <br />
                            <span style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <span>Solidity Version: 0.8.15</span>
                                <span>License: MIT</span>
                            </span><br />
                            <p style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
                                <p>
                                    Source Code<br />
                                    <Button
                                        // className="btn btn-success"
                                        variant="primary"
                                        onClick={() => {
                                            fetchFileContents(selectedModuleValue);
                                        }}
                                    >
                                        Copy
                                    </Button>
                                </p>
                                <p>
                                    Constructor ABI-encoded <br />
                                    <Button
                                        // className="btn btn-danger"
                                        variant="success"
                                        onClick={() => {
                                            swal('Success', 'Copy Success', 'success')
                                            copyToClipboard(encodedABI)
                                        }}
                                    >
                                        Copy
                                    </Button>
                                </p>
                            </p>
                        </p>
                        <hr />
                        {/* <hr />
                        <h5>Input New {modifying[2]}</h5>
                        <input className='form-control' /> */}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="danger light"
                            onClick={() => setModalWithTooltip(false)}
                        >
                            Close
                        </Button>
                        <Button
                            variant="primary"
                            onClick={deployContract}
                        >
                            Confirm
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    )
}
export default CreateToken;

export const mustFillDialog = (valueMustFill) => {
    const infoSymbol = String.fromCharCode(0x2139);
    return (
        <span
            className="text-primary"
            style={{ position: 'relative', marginLeft: '10px' }}
            onMouseEnter={(e) => {
                e.currentTarget.lastChild.style.display = 'block';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.lastChild.style.display = 'none';
            }}
            onClick={(e) => {
                e.currentTarget.lastChild.style.display = 'block';
            }}
        >
            {/* &#128156; */}
            &#9432;
            <div
                style={{
                    display: 'none',
                    position: 'absolute',
                    top: '20px',
                    left: '25vw',
                    transform: 'translateX(-50%)',
                    width: '50vw',
                    backgroundColor: 'white',
                    padding: '10px',
                    borderRadius: '10px',
                    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
                    zIndex: '999',
                }}
            >
                {valueMustFill}
            </div>
        </span>
    )
}

export const moduleDatas = (language) => [
    {
        text:
            language === 'english'
                ? '0 Tax Basic'
                : language === 'chinese'
                    ? '0税基础代币'
                    : '0稅基礎代幣',
        description:
            language === 'english'
                ?
                <span>
                    0 Tax For Transaction <br />
                    Lowest Gas Fee In All Template
                </span>

                : language === 'chinese'
                    ?
                    <span>
                        该代币模板没有税率 <br />
                        交易所需要的矿工费为最低
                    </span>
                    :
                    <span>
                        該代幣模板沒有稅率 <br />
                        交易所需要的礦工費為最低
                    </span>,
        fee: '0.05 BNB',
    },
    {
        text:
            language === 'english'
                ? 'Market & Liquidity'
                : language === 'chinese'
                    ? '营销回流代币'
                    : '營銷回流代幣',
        description:
            language === 'english'
                ?
                <span>
                    This Template Provide 2 Taxes :<br />
                    Marketing {mustFillDialog("Dev take profits from this tax")} <br />
                    Liquidity {mustFillDialog("This enlarges the liquidity pool, which could stabalizes the price")} <br />
                </span>
                : language === 'chinese'
                    ?
                    <span>
                        该代币模板提供两种税率 :<br />
                        营销 {mustFillDialog("营销税率可以为项目拥有者提供收益")} <br />
                        回流 {mustFillDialog("回流会使的池子越来越大, 稳定币价")} <br />
                    </span>
                    :
                    <span>
                        該代幣模板提供兩種稅率 :<br />
                        營銷 {mustFillDialog("營銷稅率可以為項目擁有者提供收益")} <br />
                        回流 {mustFillDialog("回流會使的池子越來越大, 穩定幣價")} <br />
                    </span>,
        fee: '0.15 BNB',
    },
    {
        text:
            language === 'english'
                ? 'Reward, Market & Liquidity'
                : language === 'chinese'
                    ? '分红营销回流代币'
                    : '分紅營銷回流代幣',
        description:

            language === 'english'
                ? `This template contains reflection, marketing and liquidity fee. The liquidity fee would enlarge the liquidity pool, the marketing fee would make profits to the project owner, and the reflection fee rewards the holders.`
                : language === 'chinese'
                    ? '该代币模板提供分红,营销以及回流税率, 回流会使的池子越来越大, 稳定币价, 营销税率可以为项目拥有者提供收益, 分红税率则可为持币者带来收益'
                    : '該代幣模板提供分紅,營銷以及回流稅率, 回流會使的池子越來越大, 穩定幣價, 營銷稅率可以為項目擁有者提供收益, 分紅稅率則可為持幣者帶來收益',
        fee: '0.2 BNB',
    },
]

